/* AiComponent.jsx */
import React from "react";
import "./style.css";
import Trusted from "../../../../../assets/images/common/trusted.png";
import RightSectionImage from "../../../../../assets/images/common/trustimage.png";

// Import payment logos (make sure you have these images in your assets folder)
import VisaLogo from "../../../../assets/images/home/payment_icons/visa.png";
import UpiLogo from "../../../../assets/images/home/payment_icons/upi.png";
import RupayLogo from "../../../../assets/images/home/payment_icons/rupay.png";

// Import secure payment icon/logo
import SecurePaymentIcon from "../../../../assets/images/home/payment_icons/secure_payment.png";

const tools = [
  {
    title: "Tested Suppliers",
    description: "Ready to source products with direct access to 20,000+ trusted suppliers.",
    details: ["Trusted partnership", "Supplier credibility", "Performance ratings", "Quality check"],
    icon: "✅",
  },
  {
    title: "Transparent Pricing",
    description: "No surprises. Know your landed cost upfront.",
    details: ["All-inclusive pricing", "No hidden fees", "GST inputs", "Cost transparency"],
    icon: "💰",
  },
  {
    title: "Secure Payments",
    description: "Trusted payment gateways and buyer protection.",
    details: ["Multiple payment options", "Secure transactions"],
    icon: "secure-payment", // ✅ CHANGED: Use identifier instead of emoji
    customIcon: SecurePaymentIcon, // ✅ ADDED: Custom icon import
  },
  {
    title: "Partnered Support",
    description: "Domestic support assistants for sourcing and logistics.",
    details: ["Dedicated account manager", "Expert guidance", "Timely updates", "Operational support"],
    icon: "👨‍💼",
  },
  {
    title: "Optimized Delivery",
    description: "Quicker sourcing and faster delivery by air, with streamlined logistics.",
    details: ["By air (12-17 days)", "By sea (30-40 days)", "Customs clearance", "Last mile delivery"],
    icon: "🚚",
  },
  {
    title: "Dedicated Expert Team",
    description: "Our team in India and China ensures fast, reliable order fulfillment.",
    details: ["Bulk order handling", "Timely delivery", "Repeat orders", "Quality checks"],
    icon: "📈",
  },
];

export default function TrustComponent() {
  return (
    <div className="container_ai">
      <div className="title-container">
        <h2 className="heading_ai">
          Why You Can Trust <span className="imp-brand">importerr.com</span>?
        </h2>
        <img src={Trusted} alt="Trusted Badge" className="trust-badge" />
      </div>

      {/* ✅ UPDATED: text under respective numbers */}
      <p className="subheading_ai subheading_ai_split">
        <span className="sub-block">
          <span className="imp-brand-u">
            <b>15+ Years</b>
          </span>
          <span className="sub-text">of Industry Experience*</span>
        </span>

        <span className="sub-block">
          <span className="imp-brand-u">
            <b>5+ lakhs</b>
          </span>
          <span className="sub-text">orders fulfilled*</span>
        </span>
      </p>

      {/* ✅ DESKTOP: 60% cards + 40% image */}
      <div className="ai-desktop-layout">
        <div className="ai-cards-wrap">
          <div className="cards-grid">
            {tools.map((tool, index) => (
              <div key={index} className="card_ai-new">
                <div className="card-header">
                  <div className="card-icon">
                    {/* ✅ UPDATED: Check if custom icon exists */}
                    {tool.customIcon ? (
                      <img 
                        src={tool.customIcon} 
                        alt={tool.title} 
                        className="custom-icon-image"
                      />
                    ) : (
                      tool.icon
                    )}
                  </div>
                  <h3>{tool.title}</h3>
                </div>
                <p className="card-description">{tool.description}</p>
                
                {/* ✅ ADD PAYMENT LOGOS FOR SECURE PAYMENTS CARD */}
                {tool.title === "Secure Payments" && (
                  <div className="payment-logos-container">
                    <img src={VisaLogo} alt="Visa" className="payment-logo payment-logo-visa" />
                    <img src={UpiLogo} alt="UPI" className="payment-logo payment-logo-upi" />
                    <img src={RupayLogo} alt="Rupay" className="payment-logo payment-logo-rupay" />
                  </div>
                )}
                
                <div className="card-details">
                  {tool.details.map((detail, idx) => (
                    <span key={idx}>{detail}</span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="ai-image-wrap">
          <img
            src={RightSectionImage}
            alt="Importerr Preview"
            className="ai-side-image"
          />
        </div>
      </div>
    </div>
  );
}
